import { accessRole } from '../../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { FileInput, generateFormData } from '../../../../../helpers/ui/FileInput'

import apiResponse from '../../../../../services/apiResponse'

import CreateBloc from './Blocs/CreateBloc'
import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar'
import CustomSelect from '../../../GlobalComponents/CustomSelect'

var reformatOptions = function(raw, label, value) {
    return raw.map(function(data) {
        var newObj = {};
        newObj["label"] = data[label];
        newObj["value"] = data[value];

        return newObj;
    });
};

const jobType = [
    { value: 1, label: 'PNS BKPM' },
    { value: 2, label: 'PNS Non BKPM' },
    { value: 3, label: 'Non PNS' },
    { value: 4, label: 'Belum Bekerja' }
]

class IndexView extends Component {

    createBloc = new CreateBloc();

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
              { label: "Ayah Mertua", value: "L" },
              { label: "Ibu Mertua", value: "P" }
            ],
            birthOptionNationality : [
              { label: "Dalam Negeri", value: "Dalam Negeri" },
              { label: "Luar Negeri", value: "Luar Negeri" }
            ],
            birthOptionCountry: [],
            birthOptionProvince : [],
            birthOptionCity : [],
            birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
            identityOptionProvince: [],
            identityOptionCity: [],
            identityOptionDistrict: [],
            identityOptionVillage: [],
            isLocal: 1,
            pnsStatus: 1
        }
    }

    // Select Area

    handleBirthSelectNationality = (birthSelectNationality) => {
        let selected = birthSelectNationality.value;
        if (selected == "Dalam Negeri") {
            this.setState({
                birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
                isLocal: 1
            })
        } else {
            this.setState({
                birthSelectedCountry: "",
                isLocal: 0
            })
        }
    }

    handleBirthSelectCountry = (birthSelectedCountry) => {
        let selected = birthSelectedCountry.value;
        this.getBirthProvinceByCountry(selected);
    }

    getBirthProvinceByCountry(selected_uuid){
        this.createBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionProvince: reformatOptions(
                                response.result,
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionProvince({
          //is_local: 1,
          parent_uuid : selected_uuid,
          type : 2
        })
    }

    handleBirthSelectProvince = (birthSelectedProvince) => {
      let selected = birthSelectedProvince.value;
      this.getBirthCityByProvince(selected);
    }

    getBirthCityByProvince = (province_uuid) => {
      this.createBloc.regionCityChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)

                      this.setState({
                          birthOptionCity: reformatOptions(
                              response.result,
                              'region_name',
                              'region_uuid'
                          )
                      })
                  }
                  break
              case apiResponse.ERROR:

                  break
              default:
                  break
          }
      })
      this.createBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : province_uuid
      })
    }

    handleIdentitySelectProvince = (domicileSelectedProvince) => {
      let selected = domicileSelectedProvince.value;
      this.getIdentityCityByProvince(selected);
    }

    // get data city where province selected
    getIdentityCityByProvince = (province_uuid) => {
        this.createBloc.identityCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response

                        this.setState({
                            identityOptionCity: reformatOptions(
                                response.result,
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
            this.createBloc.fetchIdentityCity({
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        })
    }

    handleIdentitySelectCity = (identitySelectedCity) => {
        let selected = identitySelectedCity.value;
        this.getIdentityDistrictByCity(selected);
    }

    // get data district where city selected
    getIdentityDistrictByCity = (city_uuid) => {
        this.createBloc.identityDistrictChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response

                        this.setState({
                            identityOptionDistrict: reformatOptions(
                                response.result,
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
            this.createBloc.fetchIdentityDistrict({
            is_local: 1,
            type : 4,
            parent_uuid : city_uuid
        })
    }

    handleIdentitySelectDistrict = (identitySelectedDistrict) => {
        let selected = identitySelectedDistrict.value;
        this.getIdentityVillageByDistrict(selected);
    }

    // get data village where district selected
    getIdentityVillageByDistrict = (district_uuid) => {
        this.createBloc.identityVillageChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response

                        this.setState({
                            identityOptionVillage: reformatOptions(
                                response.result,
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
            this.createBloc.fetchIdentityVillage({
            is_local: 1,
            type : 5,
            parent_uuid : district_uuid
        })
    }

    // End Select Area

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'file') // Jika nama field fileinputnya adalah 'File', maka parameter kedua boleh dikosongkan. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              employee_uuid : this.peg_uuid,
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        // get data birth country
        this.createBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionCountry: reformatOptions(
                                response.result,
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.createBloc.fetchRegionCountry({
          type : 1
        })

        // get data birth province
        this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

        // get data province identity
        this.createBloc.identityProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            identityOptionProvince: reformatOptions(
                                response.result,
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.createBloc.fetchIdentityProvince({
          is_local: 1,
          type : 2
        })
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="mertua"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Tambah Mertua</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="name"
                                                    placeholder="Nama..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="name"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Induk Kependudukan
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                    name="family_identity_number"
                                                    placeholder="Nomor Induk Kependudukan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Induk Kependudukan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="family_identity_number"
                                                    />
                                                </Col>
                                                </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Kartu Keluarga 
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="4">
                                                    <AvField
                                                    name="familty_family_card_number"
                                                    placeholder="Nomor Kartu Keluarga..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Kartu Keluarga"
                                                    className="form-control"
                                                    id="familty_family_card_number"
                                                    />
                                                </Col>
                                            </Row>

                                        <hr />
                                        <Row>
                                            <Col md="5">
                                                <label className="fw-bold">#Tempat Lahir</label>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="tempat_lahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Dalam / Luar Negeri <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="place_of_birth_national"
                                                    errorMessage="Pilih Dalam / Luar Negeri Lahir"
                                                    onChange={this.handleBirthSelectNationality}
                                                    options={this.state.birthOptionNationality}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Dalam / Luar Negeri Lahir"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="tempat_lahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Negara <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="place_of_birth_country_uuid"
                                                    errorMessage="Pilih Negara Lahir"
                                                    onChange={this.handleBirthSelectCountry}
                                                    options={this.state.birthOptionCountry}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Negara Lahir"
                                                    defaultValue={this.state.birthSelectedCountry}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3" style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                            <label
                                                htmlFor="tempat_alhir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Provinsi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="birth_province_uuid"
                                                    errorMessage="Pilih Provinsi Lahir"
                                                    onChange={this.handleBirthSelectProvince}
                                                    options={this.state.birthOptionProvince}
                                                    validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                                                    placeholder="Pilih Provinsi Lahir"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3" style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                            <label
                                                htmlFor="tempat_lahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kota <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="place_of_birth_city_uuid"
                                                    errorMessage="Pilih Kota Lahir"
                                                    options={this.state.birthOptionCity}
                                                    validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                                                    placeholder="Pilih Kota Lahir"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3" style={ this.state.isLocal == 1 ? {display:'none'} : {}}>
                                            <label
                                                htmlFor="place_of_birth_city_text"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kota <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="place_of_birth_city_text"
                                                    placeholder="Kota..."
                                                    type="text"
                                                    errorMessage="Masukkan Kota"
                                                    className="form-control"
                                                    validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                                                    id="place_of_birth_city_text"
                                                />
                                            </Col>
                                        </Row>

                                        <hr />

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="date_of_birth"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="date_of_birth"
                                                    placeholder="Tanggal Lahir..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Lahir"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="date_of_birth"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="gender"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Mertua <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect
                                                    name="gender"
                                                    errorMessage="Pilih Jenis Mertua"
                                                    options={this.state.optionGender}
                                                    placeholder="Pilih Jenis Mertua"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label htmlFor="fieldJobType" className="col-md-3 col-form-label">Jenis Pekerjaan : <span className="text-danger">*</span></Label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="jobType"
                                                    options={jobType}
                                                    isSearchable={false}
                                                    defaultValue={1}
                                                    onChange={opt => this.setState({ pnsStatus: opt.value })}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>
                                        { this.state.pnsStatus !== 3 && this.state.pnsStatus !== 4 &&
                                            <Row className="mb-3">
                                                <Label htmlFor="fieldNIP" className="col-md-3 col-form-label">NIP : <span className="text-danger">*</span></Label>
                                                <Col md="4">
                                                    <AvField
                                                        name="nip"
                                                        placeholder="NIP..."
                                                        errorMessage="Masukkan NIP"
                                                        type="number"
                                                        className="form-control"
                                                        id="fieldNIP"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                    
                                        { this.state.pnsStatus == 3 &&
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="profession"
                                                    className="col-md-3 col-form-label"
                                                >
                                                Pekerjaan <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="profession"
                                                        placeholder="Pekerjaan..."
                                                        type="text"
                                                        errorMessage="Masukkan Pekerjaan"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="profession"
                                                    />
                                                </Col>
                                            </Row>
                                        }

                                        <hr />
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="alamat"
                                                className="col-md-3 col-form-label"
                                            >
                                            Alamat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="identity_address"
                                                    placeholder="Alamat..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Alamat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="alamat"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Provinsi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="identity_province_uuid"
                                                    errorMessage="Pilih Provinsi"
                                                    onChange={this.handleIdentitySelectProvince}
                                                    options={this.state.identityOptionProvince}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Provinsi"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Kota/Kabupaten <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="identity_city_uuid"
                                                    errorMessage="Pilih Kota"
                                                    onChange={this.handleIdentitySelectCity}
                                                    options={this.state.identityOptionCity}
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Kota"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Kecamatan
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="identity_districts_uuid"
                                                    errorMessage="Pilih Kecamatan"
                                                    onChange={this.handleIdentitySelectDistrict}
                                                    options={this.state.identityOptionDistrict}
                                                    placeholder="Pilih Kecamatan"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Desa/Kelurahan
                                            </label>
                                            <Col md="5">
                                                <CustomSelect
                                                    name="identity_village_uuid"
                                                    errorMessage="Desa/Kelurahan"
                                                    options={this.state.identityOptionVillage}
                                                    placeholder="Desa/Kelurahan"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="identity_postal_code"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kode Pos <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="identity_postal_code"
                                                    placeholder="Kode Pos..."
                                                    type="number"
                                                    errorMessage="Masukkan Kode Pos"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="identity_postal_code"
                                                />
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="phone_number"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Telepon <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="phone_number"
                                                    placeholder="Nomor Telepon..."
                                                    type="number"
                                                    errorMessage="Masukkan Nomor Telepon"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="phone_number"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                             <label
                                                htmlFor="phone_number"
                                                className="col-md-3 col-form-label"
                                            >
                                                File Pendukung
                                            </label>
                                            <Col md="6">
                                                <FileInput
                                                    name="file"
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>

                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?mertua">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?mertua'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView